export default "__VITE_ASSET__cda2454e__"